import React from "react";
import PropTypes from "prop-types";
import { Button, IconButton, Stack, Typography, CircularProgress } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import BarChartIcon from "@mui/icons-material/BarChart";

export default function ApproveBondsHeader({ setStatsOpen, refreshData, loading }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2} sx={{ mb: 1 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
        Approve Bonds
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          startIcon={<BarChartIcon />}
          onClick={() => setStatsOpen(true)}
        >
          Stats
        </Button>
        <IconButton onClick={refreshData} disabled={loading} aria-label="Refresh data" color="primary">
          {loading ? <CircularProgress size={22} /> : <RefreshIcon />}
        </IconButton>
      </Stack>
    </Stack>
  );
}

ApproveBondsHeader.propTypes = {
  setStatsOpen: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
